import React from 'react';
import "./blog.less"
import Header from "../../components/header"
import Footer from "../../components/footer"


const Index = () => {
    return (
        <div className='fixed blogWrapper'>
        <div className='container bg-blog screen-height '>
            <Header/>
            <div className='center'>
            </div>
        </div>
        <Footer/>

        </div>
    );
}

export default Index;
